import N, { createContext as Hr, useContext as Dr } from "react";
import { Switch as X, cardActionAreaClasses as O, cardContentClasses as Y, tabsClasses as S, tabClasses as jr, toolbarClasses as w, inputBaseClasses as Z, outlinedInputClasses as rr, stackClasses as Lr, buttonBaseClasses as Vr, svgIconClasses as Gr, ThemeProvider as Nr, createTheme as Ur } from "@mui/material";
import { createTheme as Kr } from "@mui/material/styles";
import { jsx as qr } from "react/jsx-runtime";
import { createSvgIcon as Jr } from "@mui/material/utils";
import { K as tr } from "./chunk.ChMTXB4R.js";
import { g as Qr } from "./chunk.DaMA6jEr.js";
import { _ as R, c as A, i as F, d as Xr, b as $r } from "./chunk.BK-hwjME.js";
import { c as n } from "./chunk.DsbGl_E4.js";
import { b as m } from "./chunk.DHZ1xb2E.js";
import { a as V, t as b } from "./chunk.c8qEmHVY.js";
const Yr = {
  palette: {
    common: {
      black: "#000000",
      white: "#FFFFFF"
    },
    action: {
      activatedOpacity: 0.54,
      hoverOpacity: 0.04,
      hover: "rgba(0, 113, 199, 0.08)",
      selected: "rgba(0, 113, 199, 0.08)",
      selectedOpacity: 0.08,
      disabled: "rgba(0, 0, 0, 0.26)",
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.26
    },
    primary: {
      main: "#0078AE",
      dark: "#005580"
    },
    success: {
      main: "#008015",
      light: "#F3F7F3",
      dark: "#205823"
    },
    error: {
      main: "#C20000",
      light: "#FCF3F3",
      dark: "#8D1D1D"
    },
    warning: {
      main: "#FFB800",
      light: "#FFF8E0",
      dark: "#846301"
    },
    info: {
      main: "#005CB9",
      light: "#F5FAFF",
      dark: "#004986"
    },
    grey: {
      900: "#111112",
      800: "#36383A",
      700: "#545658",
      600: "#63676A",
      500: "#868A8D",
      400: "#AAAEB0",
      300: "#D3D5D6",
      200: "#E5E6E7",
      100: "#EEEFEF",
      50: "#F6F7F8"
    },
    divider: "#E5E6E7",
    background: {
      default: "#F6F7F8",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#111112",
      secondary: "#36383A",
      disabled: "#63676A"
    }
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ ownerState: r, theme: t }) => {
          const e = r.startAdornment, a = r.endAdornment;
          return {
            fontSize: t.typography.body1.fontSize,
            fontWeight: t.typography.body1.fontWeight,
            letterSpacing: t.typography.body1.letterSpacing,
            lineHeight: t.typography.body1.lineHeight,
            maxWidth: r.fullWidth ? "100%" : "328px",
            paddingRight: a ? t.spacing(2) : 0,
            paddingLeft: e ? t.spacing(2) : 0,
            paddingTop: 0,
            paddingBottom: 0,
            borderRadius: 0,
            gap: t.spacing(1),
            "& fieldset legend": {
              width: 0
            },
            "&.Mui-error fieldset": {
              borderWidth: "2px"
            },
            "&:hover": {
              "& fieldset": {
                borderWidth: "2px"
              },
              "&.Mui-disabled fieldset": {
                borderWidth: "1px"
              }
            },
            "& button": {
              padding: "4px"
            },
            "& .MuiInputAdornment-root": {
              "& .MuiIcon-root,.MuiSvgIcon-root": {
                fontSize: "20px"
              }
            },
            "&.Mui-disabled .MuiInputAdornment-root": {
              "p, span": {
                color: t.palette.grey[400]
              }
            }
          };
        },
        input: ({ ownerState: r }) => ({
          height: "20px",
          width: !!(r != null && r.fullWidth) ? "100%" : "328px",
          padding: "6px 12px",
          fontSize: "14px"
        })
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: ({ ownerState: r }) => ({
          maxWidth: r.fullWidth ? "100%" : "328px",
          width: "100%",
          "& .MuiTextField-root": {
            width: "100%"
          },
          "& .MuiOutlinedInput-root": {
            padding: "6px",
            // Stick the adornments at the top of the input so that they don't move as the box gets bigger
            alignItems: r.multiple ? "start" : "center",
            "& .MuiAutocomplete-input": {
              padding: 0
            }
          },
          "&.MuiAutocomplete-root .MuiOutlinedInput-root": {
            padding: "6px 12px",
            "& .MuiAutocomplete-endAdornment": {
              right: 0,
              // Set position of clear button to relative so that it appears left of other end adornments
              position: "relative"
            }
          },
          "& .MuiInputAdornment-positionEnd": {
            // Force this class' width to match any and all end adornments
            width: "fit-content",
            paddingRight: 0
          }
        }),
        popupIndicator: ({ theme: r }) => ({
          color: r.palette.grey[800],
          marginRight: "6px",
          padding: "6px",
          "&:hover": {
            color: "revert"
          }
        }),
        clearIndicator: ({ theme: r }) => ({
          color: r.palette.grey[800],
          "&:hover": {
            color: "revert"
          },
          padding: "6px"
        }),
        endAdornment: ({ ownerState: r }) => ({
          top: r.freeSolo ? "50%" : "2px",
          transform: "revert",
          display: "flex",
          justifyContent: "start",
          alignItems: "start",
          "& .MuiSvgIcon-root": {
            fontSize: "20px"
          },
          gap: "6px"
        }),
        hasClearIcon: ({ ownerState: r }) => ({
          "& .MuiAutocomplete-endAdornment": {
            // On TextInput, remove the clear icon when not hovered or focused so that input sizes accordingly
            display: r.freeSolo ? "none" : "flex"
          },
          "&:hover,&.Mui-focused": {
            "& .MuiAutocomplete-endAdornment": {
              display: "flex"
            }
          }
        }),
        hasPopupIcon: ({ ownerState: r }) => {
          const t = r.loading ? "70px" : "48px", e = r.loading ? "108px" : "84px";
          return {
            "&.MuiAutocomplete-root .MuiOutlinedInput-root": {
              padding: `6px ${t} 6px 12px`,
              "& .MuiAutocomplete-endAdornment": {
                right: "6px",
                // For Select component, make sure end adornments' position is absolute so it sticks to the upper right of the input
                position: "absolute"
              }
            },
            "&:hover,&.Mui-focused": {
              "&.MuiAutocomplete-hasClearIcon.MuiAutocomplete-root .MuiOutlinedInput-root": {
                paddingRight: e
              }
            }
          };
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          height: "20px",
          minHeight: "20px",
          padding: "6px 48px 6px 12px"
        },
        icon: ({ theme: r }) => ({
          color: r.palette.grey[800],
          marginRight: "4px"
        }),
        iconOpen: ({ theme: r }) => ({
          color: r.palette.grey[800],
          marginRight: "4px"
        })
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: ({ ownerState: r }) => ({
          maxWidth: r.fullWidth ? "100%" : "328px",
          marginBottom: "15px"
        })
      }
    }
  },
  typography: {
    htmlFontSize: 10
  }
}, Zr = {}, o = {
  primary: {
    light: "#108DE0",
    main: "#0071C7",
    dark: "#004986"
  },
  neutral: {
    white: "#FFFFFF",
    black: "#000000",
    grey: {
      900: "#111112",
      800: "#36383A",
      700: "#545658",
      600: "#63676A",
      500: "#868A8D",
      400: "#AAAEB0",
      300: "#D3D5D6",
      200: "#E5E6E7",
      100: "#EEEFEF",
      50: "#F6F7F8"
    }
  },
  semantic: {
    success: {
      main: "#008015",
      light: "#F3FFF3",
      dark: "#005C05"
    },
    error: {
      main: "#CD0202",
      light: "#FFEFEF",
      dark: "#8E0000"
    },
    warning: {
      main: "#FDC20C",
      light: "#FBF7E6",
      dark: "#B54D08"
    },
    info: {
      main: "#005CB9",
      light: "#F1F8FF",
      dark: "#004986"
    },
    urgent: {
      main: "#FF004D",
      light: "#FFE6FF",
      dark: "#5F002D"
    }
  },
  background: {
    surface: "#FFFFFF",
    backgroundVariant: "#F6F7F8"
  },
  interaction: {
    onHover: "rgba(0, 0, 0, 0.08)",
    pressed: "rgba(0, 0, 0, 0.2)",
    selected: "rgba(0, 113, 199, 0.08)",
    disabledOutline: "rgba(0, 0, 0, 0.28)",
    disabledFill: "rgba(0, 0, 0, 0.12)",
    disabledContrastText: "rgba(255, 255, 255, 0.38)",
    disabledModalScrim: "rgba(0, 0, 0, 0.5)"
  }
}, rt = Jr(/* @__PURE__ */ qr("path", {
  d: "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 18H4V10h16zm0-13H4V5h16z"
}), "CalendarTodayOutlined");
function tt() {
  this.__data__ = [], this.size = 0;
}
var et = tt;
function at(r, t) {
  return r === t || r !== r && t !== t;
}
var z = at, it = z;
function ot(r, t) {
  for (var e = r.length; e--; )
    if (it(r[e][0], t))
      return e;
  return -1;
}
var W = ot, nt = W, st = Array.prototype, pt = st.splice;
function lt(r) {
  var t = this.__data__, e = nt(t, r);
  if (e < 0)
    return !1;
  var a = t.length - 1;
  return e == a ? t.pop() : pt.call(t, e, 1), --this.size, !0;
}
var dt = lt, ct = W;
function ut(r) {
  var t = this.__data__, e = ct(t, r);
  return e < 0 ? void 0 : t[e][1];
}
var gt = ut, bt = W;
function vt(r) {
  return bt(this.__data__, r) > -1;
}
var yt = vt, ft = W;
function ht(r, t) {
  var e = this.__data__, a = ft(e, r);
  return a < 0 ? (++this.size, e.push([r, t])) : e[a][1] = t, this;
}
var xt = ht, $t = et, mt = dt, Mt = gt, Ct = yt, kt = xt;
function M(r) {
  var t = -1, e = r == null ? 0 : r.length;
  for (this.clear(); ++t < e; ) {
    var a = r[t];
    this.set(a[0], a[1]);
  }
}
M.prototype.clear = $t;
M.prototype.delete = mt;
M.prototype.get = Mt;
M.prototype.has = Ct;
M.prototype.set = kt;
var H = M, _t = H;
function Ot() {
  this.__data__ = new _t(), this.size = 0;
}
var At = Ot;
function Ft(r) {
  var t = this.__data__, e = t.delete(r);
  return this.size = t.size, e;
}
var It = Ft;
function St(r) {
  return this.__data__.get(r);
}
var wt = St;
function Tt(r) {
  return this.__data__.has(r);
}
var Bt = Tt;
function Et(r) {
  var t = typeof r;
  return r != null && (t == "object" || t == "function");
}
var x = Et, Pt = R, Rt = x, zt = "[object AsyncFunction]", Wt = "[object Function]", Ht = "[object GeneratorFunction]", Dt = "[object Proxy]";
function jt(r) {
  if (!Rt(r))
    return !1;
  var t = Pt(r);
  return t == Wt || t == Ht || t == zt || t == Dt;
}
var U = jt, Lt = A, Vt = Lt["__core-js_shared__"], Gt = Vt, G = Gt, er = function() {
  var r = /[^.]+$/.exec(G && G.keys && G.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function Nt(r) {
  return !!er && er in r;
}
var Ut = Nt, Kt = Function.prototype, qt = Kt.toString;
function Jt(r) {
  if (r != null) {
    try {
      return qt.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var Qt = Jt, Xt = U, Yt = Ut, Zt = x, re = Qt, te = /[\\^$.*+?()[\]{}|]/g, ee = /^\[object .+?Constructor\]$/, ae = Function.prototype, ie = Object.prototype, oe = ae.toString, ne = ie.hasOwnProperty, se = RegExp(
  "^" + oe.call(ne).replace(te, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function pe(r) {
  if (!Zt(r) || Yt(r))
    return !1;
  var t = Xt(r) ? se : ee;
  return t.test(re(r));
}
var le = pe;
function de(r, t) {
  return r == null ? void 0 : r[t];
}
var ce = de, ue = le, ge = ce;
function be(r, t) {
  var e = ge(r, t);
  return ue(e) ? e : void 0;
}
var K = be, ve = K, ye = A, fe = ve(ye, "Map"), mr = fe, he = K, xe = he(Object, "create"), D = xe, ar = D;
function $e() {
  this.__data__ = ar ? ar(null) : {}, this.size = 0;
}
var me = $e;
function Me(r) {
  var t = this.has(r) && delete this.__data__[r];
  return this.size -= t ? 1 : 0, t;
}
var Ce = Me, ke = D, _e = "__lodash_hash_undefined__", Oe = Object.prototype, Ae = Oe.hasOwnProperty;
function Fe(r) {
  var t = this.__data__;
  if (ke) {
    var e = t[r];
    return e === _e ? void 0 : e;
  }
  return Ae.call(t, r) ? t[r] : void 0;
}
var Ie = Fe, Se = D, we = Object.prototype, Te = we.hasOwnProperty;
function Be(r) {
  var t = this.__data__;
  return Se ? t[r] !== void 0 : Te.call(t, r);
}
var Ee = Be, Pe = D, Re = "__lodash_hash_undefined__";
function ze(r, t) {
  var e = this.__data__;
  return this.size += this.has(r) ? 0 : 1, e[r] = Pe && t === void 0 ? Re : t, this;
}
var We = ze, He = me, De = Ce, je = Ie, Le = Ee, Ve = We;
function C(r) {
  var t = -1, e = r == null ? 0 : r.length;
  for (this.clear(); ++t < e; ) {
    var a = r[t];
    this.set(a[0], a[1]);
  }
}
C.prototype.clear = He;
C.prototype.delete = De;
C.prototype.get = je;
C.prototype.has = Le;
C.prototype.set = Ve;
var Ge = C, ir = Ge, Ne = H, Ue = mr;
function Ke() {
  this.size = 0, this.__data__ = {
    hash: new ir(),
    map: new (Ue || Ne)(),
    string: new ir()
  };
}
var qe = Ke;
function Je(r) {
  var t = typeof r;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
}
var Qe = Je, Xe = Qe;
function Ye(r, t) {
  var e = r.__data__;
  return Xe(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
var j = Ye, Ze = j;
function ra(r) {
  var t = Ze(this, r).delete(r);
  return this.size -= t ? 1 : 0, t;
}
var ta = ra, ea = j;
function aa(r) {
  return ea(this, r).get(r);
}
var ia = aa, oa = j;
function na(r) {
  return oa(this, r).has(r);
}
var sa = na, pa = j;
function la(r, t) {
  var e = pa(this, r), a = e.size;
  return e.set(r, t), this.size += e.size == a ? 0 : 1, this;
}
var da = la, ca = qe, ua = ta, ga = ia, ba = sa, va = da;
function k(r) {
  var t = -1, e = r == null ? 0 : r.length;
  for (this.clear(); ++t < e; ) {
    var a = r[t];
    this.set(a[0], a[1]);
  }
}
k.prototype.clear = ca;
k.prototype.delete = ua;
k.prototype.get = ga;
k.prototype.has = ba;
k.prototype.set = va;
var ya = k, fa = H, ha = mr, xa = ya, $a = 200;
function ma(r, t) {
  var e = this.__data__;
  if (e instanceof fa) {
    var a = e.__data__;
    if (!ha || a.length < $a - 1)
      return a.push([r, t]), this.size = ++e.size, this;
    e = this.__data__ = new xa(a);
  }
  return e.set(r, t), this.size = e.size, this;
}
var Ma = ma, Ca = H, ka = At, _a = It, Oa = wt, Aa = Bt, Fa = Ma;
function _(r) {
  var t = this.__data__ = new Ca(r);
  this.size = t.size;
}
_.prototype.clear = ka;
_.prototype.delete = _a;
_.prototype.get = Oa;
_.prototype.has = Aa;
_.prototype.set = Fa;
var Ia = _, Sa = K, wa = function() {
  try {
    var r = Sa(Object, "defineProperty");
    return r({}, "", {}), r;
  } catch {
  }
}(), Mr = wa, or = Mr;
function Ta(r, t, e) {
  t == "__proto__" && or ? or(r, t, {
    configurable: !0,
    enumerable: !0,
    value: e,
    writable: !0
  }) : r[t] = e;
}
var q = Ta, Ba = q, Ea = z;
function Pa(r, t, e) {
  (e !== void 0 && !Ea(r[t], e) || e === void 0 && !(t in r)) && Ba(r, t, e);
}
var Cr = Pa;
function Ra(r) {
  return function(t, e, a) {
    for (var i = -1, s = Object(t), l = a(t), p = l.length; p--; ) {
      var d = l[r ? p : ++i];
      if (e(s[d], d, s) === !1)
        break;
    }
    return t;
  };
}
var za = Ra, Wa = za, Ha = Wa(), Da = Ha, B = { exports: {} };
B.exports;
(function(r, t) {
  var e = A, a = t && !t.nodeType && t, i = a && !0 && r && !r.nodeType && r, s = i && i.exports === a, l = s ? e.Buffer : void 0, p = l ? l.allocUnsafe : void 0;
  function d(u, v) {
    if (v)
      return u.slice();
    var h = u.length, $ = p ? p(h) : new u.constructor(h);
    return u.copy($), $;
  }
  r.exports = d;
})(B, B.exports);
var ja = B.exports, La = A, Va = La.Uint8Array, Ga = Va, nr = Ga;
function Na(r) {
  var t = new r.constructor(r.byteLength);
  return new nr(t).set(new nr(r)), t;
}
var Ua = Na, Ka = Ua;
function qa(r, t) {
  var e = t ? Ka(r.buffer) : r.buffer;
  return new r.constructor(e, r.byteOffset, r.length);
}
var Ja = qa;
function Qa(r, t) {
  var e = -1, a = r.length;
  for (t || (t = Array(a)); ++e < a; )
    t[e] = r[e];
  return t;
}
var Xa = Qa, Ya = x, sr = Object.create, Za = /* @__PURE__ */ function() {
  function r() {
  }
  return function(t) {
    if (!Ya(t))
      return {};
    if (sr)
      return sr(t);
    r.prototype = t;
    var e = new r();
    return r.prototype = void 0, e;
  };
}(), ri = Za;
function ti(r, t) {
  return function(e) {
    return r(t(e));
  };
}
var ei = ti, ai = ei, ii = ai(Object.getPrototypeOf, Object), kr = ii, oi = Object.prototype;
function ni(r) {
  var t = r && r.constructor, e = typeof t == "function" && t.prototype || oi;
  return r === e;
}
var _r = ni, si = ri, pi = kr, li = _r;
function di(r) {
  return typeof r.constructor == "function" && !li(r) ? si(pi(r)) : {};
}
var ci = di, ui = R, gi = F, bi = "[object Arguments]";
function vi(r) {
  return gi(r) && ui(r) == bi;
}
var yi = vi, pr = yi, fi = F, Or = Object.prototype, hi = Or.hasOwnProperty, xi = Or.propertyIsEnumerable, $i = pr(/* @__PURE__ */ function() {
  return arguments;
}()) ? pr : function(r) {
  return fi(r) && hi.call(r, "callee") && !xi.call(r, "callee");
}, Ar = $i, mi = 9007199254740991;
function Mi(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= mi;
}
var Fr = Mi, Ci = U, ki = Fr;
function _i(r) {
  return r != null && ki(r.length) && !Ci(r);
}
var J = _i, Oi = J, Ai = F;
function Fi(r) {
  return Ai(r) && Oi(r);
}
var Ii = Fi, E = { exports: {} };
function Si() {
  return !1;
}
var wi = Si;
E.exports;
(function(r, t) {
  var e = A, a = wi, i = t && !t.nodeType && t, s = i && !0 && r && !r.nodeType && r, l = s && s.exports === i, p = l ? e.Buffer : void 0, d = p ? p.isBuffer : void 0, u = d || a;
  r.exports = u;
})(E, E.exports);
var Ir = E.exports, Ti = R, Bi = kr, Ei = F, Pi = "[object Object]", Ri = Function.prototype, zi = Object.prototype, Sr = Ri.toString, Wi = zi.hasOwnProperty, Hi = Sr.call(Object);
function Di(r) {
  if (!Ei(r) || Ti(r) != Pi)
    return !1;
  var t = Bi(r);
  if (t === null)
    return !0;
  var e = Wi.call(t, "constructor") && t.constructor;
  return typeof e == "function" && e instanceof e && Sr.call(e) == Hi;
}
var ji = Di, Li = R, Vi = Fr, Gi = F, Ni = "[object Arguments]", Ui = "[object Array]", Ki = "[object Boolean]", qi = "[object Date]", Ji = "[object Error]", Qi = "[object Function]", Xi = "[object Map]", Yi = "[object Number]", Zi = "[object Object]", ro = "[object RegExp]", to = "[object Set]", eo = "[object String]", ao = "[object WeakMap]", io = "[object ArrayBuffer]", oo = "[object DataView]", no = "[object Float32Array]", so = "[object Float64Array]", po = "[object Int8Array]", lo = "[object Int16Array]", co = "[object Int32Array]", uo = "[object Uint8Array]", go = "[object Uint8ClampedArray]", bo = "[object Uint16Array]", vo = "[object Uint32Array]", c = {};
c[no] = c[so] = c[po] = c[lo] = c[co] = c[uo] = c[go] = c[bo] = c[vo] = !0;
c[Ni] = c[Ui] = c[io] = c[Ki] = c[oo] = c[qi] = c[Ji] = c[Qi] = c[Xi] = c[Yi] = c[Zi] = c[ro] = c[to] = c[eo] = c[ao] = !1;
function yo(r) {
  return Gi(r) && Vi(r.length) && !!c[Li(r)];
}
var fo = yo;
function ho(r) {
  return function(t) {
    return r(t);
  };
}
var xo = ho, P = { exports: {} };
P.exports;
(function(r, t) {
  var e = Xr, a = t && !t.nodeType && t, i = a && !0 && r && !r.nodeType && r, s = i && i.exports === a, l = s && e.process, p = function() {
    try {
      var d = i && i.require && i.require("util").types;
      return d || l && l.binding && l.binding("util");
    } catch {
    }
  }();
  r.exports = p;
})(P, P.exports);
var $o = P.exports, mo = fo, Mo = xo, lr = $o, dr = lr && lr.isTypedArray, Co = dr ? Mo(dr) : mo, wr = Co;
function ko(r, t) {
  if (!(t === "constructor" && typeof r[t] == "function") && t != "__proto__")
    return r[t];
}
var Tr = ko, _o = q, Oo = z, Ao = Object.prototype, Fo = Ao.hasOwnProperty;
function Io(r, t, e) {
  var a = r[t];
  (!(Fo.call(r, t) && Oo(a, e)) || e === void 0 && !(t in r)) && _o(r, t, e);
}
var So = Io, wo = So, To = q;
function Bo(r, t, e, a) {
  var i = !e;
  e || (e = {});
  for (var s = -1, l = t.length; ++s < l; ) {
    var p = t[s], d = a ? a(e[p], r[p], p, e, r) : void 0;
    d === void 0 && (d = r[p]), i ? To(e, p, d) : wo(e, p, d);
  }
  return e;
}
var Eo = Bo;
function Po(r, t) {
  for (var e = -1, a = Array(r); ++e < r; )
    a[e] = t(e);
  return a;
}
var Ro = Po, zo = 9007199254740991, Wo = /^(?:0|[1-9]\d*)$/;
function Ho(r, t) {
  var e = typeof r;
  return t = t ?? zo, !!t && (e == "number" || e != "symbol" && Wo.test(r)) && r > -1 && r % 1 == 0 && r < t;
}
var Br = Ho, Do = Ro, jo = Ar, Lo = $r, Vo = Ir, Go = Br, No = wr, Uo = Object.prototype, Ko = Uo.hasOwnProperty;
function qo(r, t) {
  var e = Lo(r), a = !e && jo(r), i = !e && !a && Vo(r), s = !e && !a && !i && No(r), l = e || a || i || s, p = l ? Do(r.length, String) : [], d = p.length;
  for (var u in r)
    (t || Ko.call(r, u)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Go(u, d))) && p.push(u);
  return p;
}
var Jo = qo;
function Qo(r) {
  var t = [];
  if (r != null)
    for (var e in Object(r))
      t.push(e);
  return t;
}
var Xo = Qo, Yo = x, Zo = _r, rn = Xo, tn = Object.prototype, en = tn.hasOwnProperty;
function an(r) {
  if (!Yo(r))
    return rn(r);
  var t = Zo(r), e = [];
  for (var a in r)
    a == "constructor" && (t || !en.call(r, a)) || e.push(a);
  return e;
}
var on = an, nn = Jo, sn = on, pn = J;
function ln(r) {
  return pn(r) ? nn(r, !0) : sn(r);
}
var Er = ln, dn = Eo, cn = Er;
function un(r) {
  return dn(r, cn(r));
}
var gn = un, cr = Cr, bn = ja, vn = Ja, yn = Xa, fn = ci, ur = Ar, gr = $r, hn = Ii, xn = Ir, $n = U, mn = x, Mn = ji, Cn = wr, br = Tr, kn = gn;
function _n(r, t, e, a, i, s, l) {
  var p = br(r, e), d = br(t, e), u = l.get(d);
  if (u) {
    cr(r, e, u);
    return;
  }
  var v = s ? s(p, d, e + "", r, t, l) : void 0, h = v === void 0;
  if (h) {
    var $ = gr(d), L = !$ && xn(d), Q = !$ && !L && Cn(d);
    v = d, $ || L || Q ? gr(p) ? v = p : hn(p) ? v = yn(p) : L ? (h = !1, v = bn(d, !0)) : Q ? (h = !1, v = vn(d, !0)) : v = [] : Mn(d) || ur(d) ? (v = p, ur(p) ? v = kn(p) : (!mn(p) || $n(p)) && (v = fn(d))) : h = !1;
  }
  h && (l.set(d, v), i(v, d, a, s, l), l.delete(d)), cr(r, e, v);
}
var On = _n, An = Ia, Fn = Cr, In = Da, Sn = On, wn = x, Tn = Er, Bn = Tr;
function Pr(r, t, e, a, i) {
  r !== t && In(t, function(s, l) {
    if (i || (i = new An()), wn(s))
      Sn(r, t, l, e, Pr, a, i);
    else {
      var p = a ? a(Bn(r, l), s, l + "", r, t, i) : void 0;
      p === void 0 && (p = s), Fn(r, l, p);
    }
  }, Tn);
}
var En = Pr;
function Pn(r) {
  return r;
}
var Rr = Pn;
function Rn(r, t, e) {
  switch (e.length) {
    case 0:
      return r.call(t);
    case 1:
      return r.call(t, e[0]);
    case 2:
      return r.call(t, e[0], e[1]);
    case 3:
      return r.call(t, e[0], e[1], e[2]);
  }
  return r.apply(t, e);
}
var zn = Rn, Wn = zn, vr = Math.max;
function Hn(r, t, e) {
  return t = vr(t === void 0 ? r.length - 1 : t, 0), function() {
    for (var a = arguments, i = -1, s = vr(a.length - t, 0), l = Array(s); ++i < s; )
      l[i] = a[t + i];
    i = -1;
    for (var p = Array(t + 1); ++i < t; )
      p[i] = a[i];
    return p[t] = e(l), Wn(r, this, p);
  };
}
var Dn = Hn;
function jn(r) {
  return function() {
    return r;
  };
}
var Ln = jn, Vn = Ln, yr = Mr, Gn = Rr, Nn = yr ? function(r, t) {
  return yr(r, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Vn(t),
    writable: !0
  });
} : Gn, Un = Nn, Kn = 800, qn = 16, Jn = Date.now;
function Qn(r) {
  var t = 0, e = 0;
  return function() {
    var a = Jn(), i = qn - (a - e);
    if (e = a, i > 0) {
      if (++t >= Kn)
        return arguments[0];
    } else
      t = 0;
    return r.apply(void 0, arguments);
  };
}
var Xn = Qn, Yn = Un, Zn = Xn, rs = Zn(Yn), ts = rs, es = Rr, as = Dn, is = ts;
function os(r, t) {
  return is(as(r, t, es), r + "");
}
var ns = os, ss = z, ps = J, ls = Br, ds = x;
function cs(r, t, e) {
  if (!ds(e))
    return !1;
  var a = typeof t;
  return (a == "number" ? ps(e) && ls(t, e.length) : a == "string" && t in e) ? ss(e[t], r) : !1;
}
var us = cs, gs = ns, bs = us;
function vs(r) {
  return gs(function(t, e) {
    var a = -1, i = e.length, s = i > 1 ? e[i - 1] : void 0, l = i > 2 ? e[2] : void 0;
    for (s = r.length > 3 && typeof s == "function" ? (i--, s) : void 0, l && bs(e[0], e[1], l) && (s = i < 3 ? void 0 : s, i = 1), t = Object(t); ++a < i; ) {
      var p = e[a];
      p && r(t, p, a, s);
    }
    return t;
  });
}
var ys = vs, fs = En, hs = ys, xs = hs(function(r, t, e) {
  fs(r, t, e);
}), $s = xs;
const fr = /* @__PURE__ */ Qr($s), { radius: ms, size: Ms, stroke: hr } = m.sizing, y = {
  spacing: {
    inlineGap: {
      small: "8px"
    }
  },
  iconography: {
    shape: {
      height: "24px",
      width: "24px"
    }
  },
  appBar: {
    color: {
      surface: n.surface.colorContrast,
      onSurface: n.typography.highContrast,
      inputBackground: n.background.secondary
    }
  },
  button: {
    color: {
      primary: {
        surfaceEnabled: n.surface.colorEnabled,
        surfaceHover: n.surface.colorHover,
        surfacePressed: n.surface.colorPressed,
        surfaceDisabled: n.surface.disabled,
        onSurfaceEnabled: n.typography.highContrast,
        onSurfaceDisabled: n.typography.disabled,
        borderFocusRing: n.border.highContrast,
        borderSeparator: n.border.mediumEmphasis
      },
      secondary: {
        surfaceHover: n.surface.transparentHover,
        surfacePressed: n.surface.transparentPressed,
        onSurfaceEnabled: n.typography.interactiveEnabled,
        onSurfaceHover: n.typography.interactiveHover,
        onSurfacePressed: n.typography.interactivePressed,
        onSurfaceDisabled: n.typography.disabled,
        borderEnabled: n.border.neutralEnabled,
        borderHover: n.border.colorHover,
        borderPressed: n.border.colorPressed,
        borderDisabled: n.border.disabled,
        borderFocusRing: n.border.colorFocused,
        borderSeparator: n.border.lowEmphasis
      },
      tertiary: {
        surfaceHover: n.surface.transparentHover,
        surfacePressed: n.surface.transparentPressed,
        onSurfaceEnabled: n.typography.interactiveEnabled,
        onSurfaceEnabledBlack: n.typography.mediumEmphasis,
        onSurfaceEnabledWhite: n.typography.highContrast,
        onSurfaceHover: n.typography.interactiveHover,
        onSurfacePressed: n.typography.interactivePressed,
        onSurfaceDisabled: n.typography.disabled,
        borderFocusRing: n.border.colorFocused,
        borderSeparator: n.border.lowEmphasis
      }
    },
    shape: {
      default: {
        borderWeightFieldContainer: hr.weight[200],
        borderWeightFocusRing: hr.weight[100],
        insetFocusRing: Ms.unit[25],
        insetHorizontalLabel: "22px",
        insetHorizontalOptionalElement: "10px",
        insetIconButton: "14px",
        insetVertical: "14px",
        minHeight: "24px",
        minWidth: "60px",
        radiusContainer: ms.corner[900]
      },
      compact: {
        insetIconButton: "6px",
        insetVertical: "6px"
      }
    }
  },
  hyperlink: {
    textEnabled: n.typography.interactiveEnabled,
    textHover: n.typography.interactiveHover,
    textPressed: n.typography.interactivePressed
  }
};
function Cs(r) {
  return y.button.shape.default;
}
function g(r, t) {
  return `linear-gradient(${r}, ${r}), linear-gradient(${t}, ${t})`;
}
const zr = {
  palette: {
    common: {
      black: o.neutral.black,
      white: o.neutral.white
    },
    action: {
      active: o.interaction.pressed,
      activatedOpacity: 0.2,
      hoverOpacity: 0.08,
      hover: o.interaction.onHover,
      selected: o.interaction.selected,
      focusOpacity: 0.2,
      selectedOpacity: 0.08,
      disabled: o.interaction.disabledOutline,
      disabledBackground: o.interaction.disabledFill,
      disabledOpacity: 0.28,
      disabledContrastText: o.interaction.disabledContrastText,
      disabledModalScrim: o.interaction.disabledModalScrim
    },
    primary: {
      main: o.primary.main,
      dark: o.primary.dark,
      light: o.primary.light
    },
    success: {
      main: o.semantic.success.main,
      light: o.semantic.success.light,
      dark: o.semantic.success.dark
    },
    error: {
      main: o.semantic.error.main,
      light: o.semantic.error.light,
      dark: o.semantic.error.dark
    },
    warning: {
      main: o.semantic.warning.main,
      light: o.semantic.warning.light,
      dark: o.semantic.warning.dark
    },
    info: {
      main: o.semantic.info.main,
      light: o.semantic.info.light,
      dark: o.semantic.info.dark
    },
    urgent: {
      main: o.semantic.urgent.main,
      light: o.semantic.urgent.light,
      dark: o.semantic.urgent.dark
    },
    grey: {
      900: o.neutral.grey[900],
      800: o.neutral.grey[800],
      700: o.neutral.grey[700],
      600: o.neutral.grey[600],
      500: o.neutral.grey[500],
      400: o.neutral.grey[400],
      300: o.neutral.grey[300],
      200: o.neutral.grey[200],
      100: o.neutral.grey[100],
      50: o.neutral.grey[50]
    },
    divider: o.neutral.grey[200],
    // Divider default value
    dividers: {
      highEmphasis: o.neutral.grey[600],
      mediumEmphasis: o.neutral.grey[400],
      lowEmphasis: o.neutral.grey[200]
    },
    background: {
      default: o.background.surface,
      paper: o.background.surface,
      surface: o.background.surface,
      backgroundVariant: o.background.backgroundVariant
    },
    text: {
      primary: o.neutral.grey[900],
      secondary: o.neutral.grey[800],
      disabled: o.neutral.grey[400]
    },
    typography: {
      highContrast: o.neutral.white,
      highEmphasis: o.neutral.grey[900],
      mediumEmphasis: o.neutral.grey[800],
      lowEmphasis: o.neutral.grey[700],
      disabled: o.neutral.grey[400]
    }
  },
  components: {
    MuiLink: {
      defaultProps: {
        underline: "none"
      },
      styleOverrides: {
        root: ({ theme: r }) => ({
          textTransform: "none",
          ...r.typography.body100,
          fontWeight: 600,
          borderBottom: "1px solid transparent",
          "&:hover": {
            color: r.palette.primary.dark,
            borderBottom: `1px solid ${r.palette.primary.dark}`,
            cursor: "pointer"
          },
          "&:active": {
            color: n.typography.interactivePressed,
            borderBottom: `1px solid ${n.typography.interactivePressed}`,
            cursor: "pointer"
          }
        })
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: !0
      }
    },
    MuiButton: {
      defaultProps: {
        disableRipple: !0,
        disableFocusRipple: !0,
        disableElevation: !0
      },
      styleOverrides: {
        root: ({ ownerState: r, theme: t }) => ({
          fontSize: t.typography.button.fontSize,
          height: t.spacing(5),
          ...typeof r.children == "string" ? {
            outlineOffset: "2px",
            whiteSpace: "nowrap",
            padding: "8px 16px",
            ...r.size === "small" && {
              fontSize: "12px",
              height: "24px",
              padding: "4px 8px",
              overflow: "hidden",
              overflowWrap: "anywhere",
              textOverflow: "ellipsis",
              lineHeight: "0px",
              position: "relative",
              "&.MuiButton-startIcon": {
                marginRight: "4px"
              },
              "&.MuiButton-endIcon": {
                marginLeft: "4px"
              }
            }
          } : {
            minWidth: t.spacing(5),
            width: t.spacing(5),
            padding: t.spacing(1),
            ...r.size === "small" && {
              color: t.palette.grey[800],
              minWidth: "20px",
              padding: "4px",
              width: "auto",
              height: "auto"
            }
          },
          "&.Mui-focusVisible": {
            outline: `2px solid ${t.palette.primary.main}`
          },
          ...r.variant === "contained" ? {
            "&:active": {
              backgroundColor: "#003A6B"
            }
          } : {
            "&:hover": {
              backgroundColor: y.button.color.secondary.surfaceHover,
              color: t.palette.primary.dark,
              ...r.variant === "outlined" && {
                borderColor: t.palette.primary.dark
              }
            },
            "&:active": {
              backgroundColor: t.palette.action.active,
              color: t.palette.primary.dark
            },
            ...r.variant === "outlined" && {
              border: `1px solid ${t.palette.primary.main}`
            }
          }
        })
      }
    },
    MuiButtonGroup: {
      styleOverrides: {
        firstButton: ({ ownerState: r, theme: t }) => ({
          outlineOffset: "-3px",
          borderRightColor: r.variant === "contained" ? y.button.color.primary.borderSeparator : y.button.color.secondary.borderSeparator,
          "&.Mui-disabled": {
            borderRightColor: r.variant === "contained" ? t.palette.dividers.mediumEmphasis : y.button.color.secondary.borderSeparator
          },
          "&:hover": {
            borderRightColor: "transparent"
          },
          "&.Mui-focusVisible": {
            outline: `1px solid ${r.variant === "contained" ? t.palette.common.white : t.palette.primary.main}`
          }
        }),
        lastButton: ({ ownerState: r, theme: t }) => ({
          marginLeft: r.variant === "contained" ? 0 : "-1px",
          outlineOffset: "-3px",
          borderLeftColor: "transparent",
          "&:hover": {
            borderLeftColor: "transparent"
          },
          "&.Mui-focusVisible": {
            outline: `1px solid ${r.variant === "contained" ? t.palette.common.white : t.palette.primary.main}`
          }
        })
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme: r, ownerState: t }) => ({
          borderRadius: 4,
          "&.Mui-focusVisible": {
            outlineOffset: "2px",
            outline: "1px solid",
            outlineColor: `${r.palette.primary.main}`
          },
          "&:hover": {
            backgroundColor: r.palette.action.hover
          },
          "&:active": {
            backgroundColor: r.palette.action.active
          },
          ...(!t.color || t.color === "default") && {
            color: r.palette.primary.main
            // only set color if none was provided via the `color` prop (to maintain MUI's support for the `color` prop on their InputButton)
          }
        })
      }
    },
    MuiIcon: {
      defaultProps: {
        baseClassName: "material-icons-outlined"
      }
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: !0
      },
      styleOverrides: {
        root: ({ theme: r }) => ({
          position: "relative",
          marginBottom: "4px",
          "&.Mui-focused": {
            color: r.palette.text.secondary
          },
          "&.Mui-error": {
            color: r.palette.error.dark
          }
        }),
        asterisk: ({ theme: r }) => ({
          marginLeft: "2px",
          "&.Mui-error": {
            color: r.palette.error.dark
          }
        }),
        shrink: ({ theme: r }) => ({
          transform: "translate(0, 0) scale(1)",
          lineHeight: r.typography.subtitle2.lineHeight
        })
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: ({ ownerState: r }) => ({
          margin: 0,
          ...r.control.type === X && {
            justifyContent: "space-between",
            flexDirection: "row-reverse",
            display: "flex"
          }
        }),
        label: ({ ownerState: r, theme: t }) => ({
          ...r.control.type === X && {
            marginRight: t.spacing(0.5)
          }
        })
      }
    },
    // `maxWidth` set at MuiTextField since it is the parent component of most form fields (except Select and SelectV2)
    MuiTextField: {
      styleOverrides: {
        root: ({ theme: r, ownerState: t }) => ({
          maxWidth: t.fullWidth ? "100%" : "328px",
          "& .clearButton": {
            marginRight: r.spacing(1)
          }
        })
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ ownerState: r, theme: t }) => {
          const e = r.startAdornment, a = r.endAdornment;
          return {
            fontSize: t.typography.body1.fontSize,
            fontWeight: t.typography.body1.fontWeight,
            letterSpacing: t.typography.body1.letterSpacing,
            lineHeight: t.typography.body1.lineHeight,
            // Add 16px padding on sides if have adornments
            paddingRight: t.spacing(a ? 2 : 1),
            paddingLeft: t.spacing(e ? 2 : 1),
            paddingTop: t.spacing(1),
            paddingBottom: t.spacing(1),
            "& fieldset legend": {
              width: 0
            },
            "&.Mui-error fieldset": {
              borderWidth: "2px"
            },
            "&:hover": {
              "& fieldset": {
                borderWidth: "2px"
              },
              "&.Mui-disabled fieldset": {
                borderWidth: "1px"
              }
            },
            "&.Mui-disabled .MuiInputAdornment-root": {
              "p, span": {
                color: t.palette.grey[400]
              }
            }
          };
        },
        input: ({ ownerState: r, theme: t }) => {
          const e = !!(r != null && r.fullWidth), a = r.size === "small" ? t.spacing(0, 1) : (
            // Set 8px of padding all around unless has adornments
            t.spacing(1)
          );
          return {
            // MUI manually sets height but we want height based off of padding and font size
            height: "revert",
            width: e ? "100%" : "328px",
            padding: a
          };
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: ({ theme: r, ownerState: t }) => {
          const e = t.variant === "outlinedSelected" || t.variant === "filledSelected", a = t.variant === "outlined" || t.variant === "outlinedSelected", i = r.palette.grey[200];
          let s = {
            outlineOffset: "-4px",
            padding: r.spacing(1, 1),
            height: r.spacing(5),
            borderRadius: r.spacing(4.5),
            color: r.palette.text.primary,
            border: "1px solid transparent",
            background: g(i, "transparent")
          };
          return a && (s = {
            ...s,
            background: "transparent",
            border: `1px solid ${r.palette.grey[500]}`
          }), e && (s = {
            ...s,
            color: r.palette.primary.dark,
            border: `1px solid ${r.palette.primary.main}`,
            background: a ? g(r.palette.action.selected, "transparent") : g(
              r.palette.action.selected,
              i
            )
          }), {
            ...s,
            "&.Mui-disabled": {
              opacity: 0.6,
              "&.Mui-focusVisible": {
                outline: 0
              }
            },
            "&.Mui-focusVisible": {
              background: s.background
            },
            ...t.clickable && {
              "&.MuiChip-clickable": {
                "&:hover": {
                  background: e ? a ? g(
                    r.palette.action.hover,
                    r.palette.action.selected
                  ) : `${g(
                    r.palette.action.hover,
                    r.palette.action.selected
                  )}, linear-gradient(${i}, ${i})` : a ? r.palette.action.hover : g(
                    r.palette.action.hover,
                    i
                  )
                }
              },
              "&:hover": {
                background: e ? a ? g(
                  r.palette.action.hover,
                  r.palette.action.selected
                ) : `${g(
                  r.palette.action.hover,
                  r.palette.action.selected
                )}, linear-gradient(${i}, ${i})` : a ? r.palette.action.hover : g(
                  r.palette.action.hover,
                  i
                ),
                "&:active,&.Mui-active": {
                  background: e ? a ? g(
                    r.palette.action.active,
                    r.palette.action.selected
                  ) : `${g(
                    r.palette.action.active,
                    r.palette.action.selected
                  )}, linear-gradient(${r.palette.action.selected}, ${r.palette.action.selected}), linear-gradient(${i}, ${i})` : a ? r.palette.action.active : g(
                    r.palette.action.active,
                    i
                  )
                }
              },
              "&:active,&.Mui-active": {
                background: e ? a ? g(
                  r.palette.action.active,
                  r.palette.action.selected
                ) : `${g(
                  r.palette.action.active,
                  r.palette.action.selected
                )}, linear-gradient(${r.palette.action.selected}, ${r.palette.action.selected}), linear-gradient(${i}, ${i})` : a ? r.palette.action.active : g(
                  r.palette.action.active,
                  i
                )
              },
              "&.Mui-focusVisible": {
                background: s.background,
                outline: (a || e) && `1px solid ${r.palette.primary.main}`,
                border: t.variant === "filled" && `1px solid ${r.palette.primary.main}`
              }
            }
          };
        },
        label: ({ theme: r, ownerState: t }) => {
          const e = t.variant === "outlinedSelected" || t.variant === "filledSelected";
          return {
            paddingLeft: r.spacing(1),
            paddingRight: r.spacing(1),
            fontSize: r.typography.body1.fontSize,
            fontWeight: r.typography.body1.fontWeight,
            letterSpacing: r.typography.body1.letterSpacing,
            ...e && {
              fontWeight: V
            }
          };
        },
        avatar: {
          margin: 0,
          width: "24px",
          height: "24px"
        },
        icon: ({ theme: r }) => ({
          marginLeft: "4px",
          marginRight: 0,
          width: "24px",
          height: "24px",
          color: r.palette.grey[800]
        }),
        deleteIcon: ({ theme: r }) => ({
          margin: 0,
          marginLeft: "-2px",
          color: r.palette.grey[500],
          "&:hover": {
            color: r.palette.grey[900]
          }
        })
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          marginLeft: 0,
          marginTop: r.spacing(0.5),
          display: "flex",
          alignItems: "center",
          gap: r.spacing(0.5),
          "&.Mui-error::before": {
            content: '"error_outline"',
            fontFamily: "Material Icons",
            fontSize: "14px",
            color: r.palette.error.dark
          },
          "&.Mui-error": {
            color: r.palette.error.dark
          }
        })
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          width: r.spacing(5),
          height: r.spacing(5),
          "& svg": {
            border: "1px solid transparent",
            borderRadius: "4px"
          },
          "&:hover": {
            backgroundColor: r.palette.action.hover,
            color: r.palette.primary.dark
          },
          "&.Mui-focusVisible": {
            "& svg": {
              borderColor: r.palette.primary.main
            }
          }
        })
      }
    },
    MuiDateCalendar: {
      styleOverrides: {
        root: ({ theme: r }) => {
          var t, e;
          return {
            "& svg": {
              color: (t = r.palette) != null && t.grey ? (e = r.palette) == null ? void 0 : e.grey[900] : void 0
            }
          };
        }
      }
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: ({ theme: r }) => {
          var t, e;
          return {
            "& svg": {
              color: (t = r.palette) != null && t.grey ? (e = r.palette) == null ? void 0 : e.grey[900] : void 0
            }
          };
        }
      }
    },
    MuiDatePicker: {
      defaultProps: {
        components: {
          OpenPickerIcon: rt
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: ({ theme: r }) => ({
          backgroundColor: r.palette.grey[800]
        }),
        arrow: ({ theme: r }) => ({
          color: r.palette.grey[800]
        })
      }
    },
    MuiPopover: {
      styleOverrides: {
        paper: ({ theme: r, ownerState: t }) => {
          var e, a;
          return {
            /** Add a 4px offset if the popover is anchored below the element
             *  Will affect Select, ProfileMenu, AppSwitcher, SplitButton, etc.
             **/
            ...((e = t.anchorOrigin) == null ? void 0 : e.vertical) === "bottom" && ((a = t.transformOrigin) == null ? void 0 : a.vertical) === "top" && {
              marginTop: r.spacing(0.5)
            }
          };
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          display: "flex",
          justifyContent: "space-between",
          [r.breakpoints.up("xs")]: {
            minHeight: r.spacing(6)
          },
          "&:active": {
            backgroundColor: n.surface.transparentPressed
          },
          "&.Mui-selected": {
            "&:active": {
              backgroundColor: n.surface.selectedPressed
            }
          }
        })
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          color: r.palette.grey[900]
        })
      }
    },
    MuiSelect: {
      styleOverrides: {
        icon: ({ theme: r, ownerState: t }) => ({
          color: r.palette.grey[800],
          right: t.size === "small" ? r.spacing(2) : r.spacing(3)
        }),
        iconOpen: ({ theme: r, ownerState: t }) => ({
          color: r.palette.grey[800]
        }),
        root: () => ({
          // MUI override
          padding: "0"
        }),
        select: ({ theme: r, ownerState: t }) => {
          const e = t.size === "small" ? r.spacing(1) : r.spacing(2);
          return {
            paddingBottom: e,
            paddingLeft: r.spacing(2),
            paddingTop: e,
            "&.MuiOutlinedInput-input": {
              // Input text padding to account for icon
              paddingRight: `calc(${r.spacing(6)} + ${e})`
            }
          };
        }
      },
      defaultProps: {
        IconComponent: tr
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        popupIndicator: ({ theme: r }) => ({
          color: r.palette.grey[800],
          marginRight: r.spacing(1),
          padding: r.spacing(1),
          "&:hover": {
            color: "revert"
          }
        }),
        clearIndicator: ({ theme: r }) => ({
          color: r.palette.grey[800],
          padding: r.spacing(1),
          "&:hover": {
            color: "revert"
          }
        }),
        endAdornment: ({ theme: r, ownerState: t }) => ({
          // Search uses freeSolo, which has different styling for the end adornment
          top: t.freeSolo ? "50%" : r.spacing(1),
          transform: "revert",
          display: "flex",
          justifyContent: "start",
          alignItems: "start",
          gap: r.spacing(1)
        }),
        tag: {
          margin: 0
        },
        hasPopupIcon: ({ theme: r, ownerState: t }) => {
          const e = t.size === "small", a = e ? t.loading ? r.spacing(11) : r.spacing(7) : t.loading ? r.spacing(12) : r.spacing(8), i = e ? t.loading ? r.spacing(16) : r.spacing(12) : t.loading ? r.spacing(17) : r.spacing(13);
          return {
            "&.MuiAutocomplete-root .MuiOutlinedInput-root": {
              padding: r.spacing(1),
              "& .MuiAutocomplete-endAdornment": {
                right: r.spacing(1),
                // For Select component, make sure end adornments' position is absolute so it sticks to the upper right of the input
                position: "absolute"
              },
              // Override MUI's padding
              "&.MuiInputBase-adornedEnd": {
                paddingRight: r.spacing(1)
              }
            },
            "&.MuiAutocomplete-hasClearIcon.MuiAutocomplete-root .MuiOutlinedInput-root": {
              paddingRight: a
            },
            "&:hover,&.Mui-focused": {
              "&.MuiAutocomplete-hasClearIcon.MuiAutocomplete-root .MuiOutlinedInput-root": {
                paddingRight: i
              }
            }
          };
        },
        hasClearIcon: ({ ownerState: r, theme: t }) => ({
          "&.MuiAutocomplete-root .MuiOutlinedInput-root": {
            paddingRight: t.spacing(1),
            "&.MuiInputBase-adornedEnd": {
              paddingRight: t.spacing(2)
            }
          },
          "& .MuiAutocomplete-endAdornment": {
            // On TextInput, remove the clear icon when not hovered or focused so that input sizes accordingly
            display: r.freeSolo ? "none" : "flex"
          },
          "&:hover,&.Mui-focused": {
            "& .MuiAutocomplete-endAdornment": {
              display: "flex"
            }
          }
        }),
        inputRoot: ({ theme: r }) => ({
          width: "100%",
          padding: r.spacing(1),
          "& .MuiAutocomplete-input": {
            minWidth: r.spacing(4)
          }
        }),
        root: ({ ownerState: r, theme: t }) => {
          const e = {
            maxWidth: r.fullWidth ? "100%" : "328px",
            width: "100%",
            "& .MuiTextField-root": {
              width: "100%"
            },
            "& .MuiOutlinedInput-root": {
              // Stick the adornments at the top of the input so that they don't move as the box gets bigger
              alignItems: r.multiple ? "start" : "center",
              "& .MuiAutocomplete-endAdornment": {
                right: 0,
                // Set position of clear button to relative so that it appears left of other end adornments
                position: "relative"
              },
              "&.MuiInputBase-adornedStart": {
                paddingLeft: t.spacing(2)
              },
              "&.MuiInputBase-adornedEnd": {
                paddingRight: t.spacing(2)
              },
              "&.MuiInputBase-sizeSmall": {
                padding: t.spacing(1)
              },
              "&.MuiInputBase-sizeSmall.MuiInputBase-adornedStart": {
                paddingLeft: t.spacing(2)
              },
              "&.MuiInputBase-sizeSmall.MuiInputBase-adornedEnd": {
                paddingRight: t.spacing(2)
              },
              "&.MuiInputBase-sizeSmall .MuiAutocomplete-input": {
                padding: t.spacing(0, 1)
              },
              "& .MuiAutocomplete-input": {
                padding: t.spacing(1)
              },
              gap: r.multiple ? t.spacing(1) : 0
            },
            "& .MuiInputAdornment-positionEnd": {
              // Force this class' width to match any and all end adornments
              width: "fit-content",
              gap: t.spacing(1)
            }
          };
          return r.size === "small" && (e["& .MuiOutlinedInput-root"] = {
            ...e["& .MuiOutlinedInput-root"],
            "& .MuiAutocomplete-endAdornment": {
              top: 0,
              right: 0,
              // Set position of clear button to relative so that it appears left of other end adornments
              position: "relative"
            },
            "& .MuiAutocomplete-input": {
              padding: t.spacing(0, 1)
            },
            "& .MuiAutocomplete-popupIndicator": {
              marginRight: 0
            },
            "& .MuiChip-sizeSmall": {
              height: t.spacing(3),
              padding: t.spacing(1),
              "& .MuiChip-labelSmall": {
                fontSize: t.typography.body2.fontSize,
                paddingLeft: 0
              }
            }
          }), e;
        },
        // .MuiAutocomplete-listbox.MuiAutocomplete-option overrides the min-height and hover/focused logic of .MuiAutocomplete-option, so need to override here
        listbox: ({ theme: r }) => ({
          "& .MuiAutocomplete-option": {
            [r.breakpoints.up("sm")]: {
              minHeight: r.spacing(6)
            },
            "&:hover,&.Mui-focused": {
              backgroundColor: n.surface.transparentHover
            },
            "&:active": {
              backgroundColor: n.surface.transparentPressed
            },
            '&[aria-selected="true"]': {
              "&:active,:hover:active": {
                backgroundColor: n.surface.selectedPressed
              }
            }
          }
        }),
        paper: ({ theme: r }) => ({
          marginTop: r.spacing(0.5)
        })
      },
      defaultProps: {
        popupIcon: N.createElement(tr)
      }
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: "h1",
          h2: "h2",
          h3: "h3",
          h4: "h4",
          h5: "h5",
          h6: "h6",
          subtitle1: "h6",
          subtitle2: "h6",
          body1: "p",
          body2: "p",
          display1: "p",
          display2: "p",
          display3: "p",
          display100: "p",
          display200: "p",
          display300: "p",
          display400: "p",
          heading100: "h1",
          heading200: "h2",
          heading300: "h3",
          heading400: "h4",
          heading500: "h5",
          heading600: "h6",
          subtitle100: "h6",
          subtitle200: "h6",
          subtitle300: "h6",
          subtitle400: "h6",
          body100: "p",
          body200: "p",
          overline: "p",
          caption: "p",
          button: "p",
          inherit: "p"
        }
      }
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: ({ theme: r }) => ({
          ".MuiSwitch-thumb": {
            border: `1px solid ${r.palette.grey[400]}`,
            boxSizing: "border-box"
          },
          "&:hover": {
            backgroundColor: r.palette.action.hover
          },
          "&:active": {
            backgroundColor: r.palette.action.active
          },
          "&.Mui-disabled": {
            color: r.palette.grey[300],
            "&+.MuiSwitch-track": {
              opacity: r.palette.action.disabledOpacity
            }
          },
          "&.Mui-checked": {
            ".MuiSwitch-thumb": {
              border: "none"
            },
            "&:hover": {
              backgroundColor: r.palette.action.hover,
              color: r.palette.primary.dark
            },
            "&:active": {
              backgroundColor: r.palette.action.active
            },
            "&.Mui-disabled": {
              color: r.palette.grey[300],
              ".MuiSwitch-thumb": {
                border: `1px solid ${r.palette.grey[400]}`
              },
              "&+.MuiSwitch-track": {
                backgroundColor: r.palette.common.black
              }
            }
          },
          "&.Mui-focusVisible": {
            "& .MuiSwitch-thumb::before": {
              content: '""',
              padding: "1px",
              width: "inherit",
              height: "inherit",
              border: "1px solid transparent",
              borderColor: r.palette.primary.light,
              display: "inherit",
              position: "relative",
              left: "-2px",
              top: "-2px"
            }
          }
        })
      }
    },
    MuiRating: {
      styleOverrides: {
        iconEmpty: ({ theme: r }) => ({
          color: r.palette.grey[800]
        }),
        iconFilled: ({ theme: r }) => ({
          color: r.palette.primary.main
        }),
        root: ({ theme: r }) => ({
          "&.Mui-focusVisible .MuiRating-iconActive": {
            outline: `1px solid ${r.palette.primary.main}`
          }
        })
      }
    },
    MuiFormGroup: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          "&.MuiRadioGroup-row": {
            gap: r.spacing(1)
          }
        })
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          "& svg": {
            border: "1px solid transparent",
            borderRadius: "100%"
          },
          "&:hover": {
            backgroundColor: r.palette.action.hover,
            color: r.palette.primary.dark
          },
          "&.Mui-focusVisible": {
            "& svg": {
              borderColor: r.palette.primary.main
            }
          }
        })
      }
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          "& svg": { color: r.palette.grey[900] },
          "& .MuiCircularProgress-root svg": {
            color: "revert"
          },
          ".Mui-disabled > & svg": { color: r.palette.grey[400] },
          color: r.palette.grey[700],
          "& button": {
            color: r.palette.grey[700]
          }
        }),
        positionStart: {
          marginRight: 0
        },
        positionEnd: ({ theme: r }) => ({
          marginLeft: 0,
          "& button": {
            marginRight: 0
          }
        })
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
            margin: 0
          },
          "&::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0
          },
          "&[type=number]": {
            MozAppearance: "textfield"
          }
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          "& > .MuiLinearProgress-bar": {
            backgroundColor: r.palette.primary.light
          },
          width: "100%",
          backgroundColor: r.palette.grey[200]
        })
      }
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          color: r.palette.primary.light,
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round"
          }
        })
      }
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        ol: {
          "&": {
            fontWeight: 600
          }
        },
        separator: {
          "&": {
            fontWeight: 400
          }
        },
        li: ({ theme: r }) => ({
          "&:last-child": {
            fontWeight: 400,
            color: r.palette.text.primary
          }
        })
      }
    },
    MuiDivider: {
      styleOverrides: {
        root: ({ theme: r }) => {
          var t;
          return {
            borderColor: (t = r.palette.dividers) == null ? void 0 : t.mediumEmphasis
          };
        }
      }
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: !1
      },
      styleOverrides: {
        root: ({ theme: r }) => ({
          paddingLeft: r.spacing(3),
          paddingRight: r.spacing(3),
          [r.breakpoints.between("sm", "md")]: {
            paddingLeft: r.spacing(4),
            paddingRight: r.spacing(4)
          },
          [r.breakpoints.between("md", "lg")]: {
            paddingLeft: r.spacing(5),
            paddingRight: r.spacing(5)
          },
          [r.breakpoints.between("lg", "xl")]: {
            paddingLeft: r.spacing(5),
            paddingRight: r.spacing(5)
          },
          [r.breakpoints.up("xl")]: {
            paddingLeft: r.spacing(6),
            paddingRight: r.spacing(6)
          }
        })
      }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          width: 512
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          ...r.typography.subtitle1,
          padding: 0
        })
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          padding: r.spacing(0, 3)
        })
      }
    },
    MuiDialogActions: {
      defaultProps: {
        disableSpacing: !0
      },
      styleOverrides: {
        root: ({ theme: r }) => ({
          padding: r.spacing(3),
          gap: r.spacing(1),
          [r.breakpoints.down("sm")]: {
            flexDirection: "column-reverse"
          }
        })
      }
    },
    Select: {
      styleOverrides: {
        root: ({ ownerState: r }) => ({
          maxWidth: r.fullWidth ? "100%" : "328px"
        })
      }
    },
    SelectV2: {
      styleOverrides: {
        // This theme overrides for SelectV2 when `autosuggest` prop is false
        defaultRoot: ({ ownerState: r }) => ({
          maxWidth: r.fullWidth ? "100%" : "328px"
        })
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          backgroundColor: r.palette.background.surface,
          top: 0,
          boxShadow: "none",
          borderBottom: `1px solid ${r.palette.divider}`
        })
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          color: r.palette.primary.main,
          fontSize: r.typography.button.fontSize,
          fontWeight: r.typography.button.fontWeight,
          lineHeight: r.typography.button.lineHeight,
          letterSpacing: r.typography.button.letterSpacing,
          "&.Mui-focusVisible": {
            border: `1px solid ${r.palette.primary.main}`,
            backgroundColor: "transparent"
          },
          "&:hover": {
            background: r.palette.action.hover
          },
          "&:active": {
            color: r.palette.primary.dark,
            background: r.palette.action.active
          },
          "&.Mui-selected": {
            color: r.palette.grey[900],
            background: g(
              r.palette.action.selected,
              r.palette.action.selected
            ),
            "&:hover": {
              background: g(
                r.palette.action.selected,
                r.palette.action.selected
              )
            },
            "&.Mui-focusVisible": {
              backgroundColor: "transparent"
            }
          },
          "&.Mui-disabled": {
            color: r.palette.grey[400]
          },
          "&.MuiPaginationItem-ellipsis": {
            color: r.palette.grey[800],
            background: "transparent"
          }
        })
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          backgroundColor: "transparent",
          borderBottom: `1px solid ${r.palette.divider}`,
          "&:before": {
            display: "none"
          },
          "&:last-of-type": {
            borderRadius: "0px",
            border: "none"
          }
        })
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        expandIconWrapper: ({ theme: r }) => ({
          borderRadius: "4px",
          color: r.palette.typography.lowEmphasis,
          transition: "unset",
          "&:hover": {
            backgroundColor: r.palette.action.hover,
            color: r.palette.primary.dark
          },
          padding: r.spacing(1)
        })
      }
    },
    NavigationalTabBar: {
      styleOverrides: {
        tabs: ({ theme: r }) => ({
          boxSizing: "border-box",
          backgroundColor: r.palette.background.surface,
          position: "fixed",
          width: "100%",
          "& .MuiTabs-flexContainer": {
            gap: r.spacing(4)
          },
          zIndex: r.zIndex.appBar
        }),
        tab: ({ theme: r }) => ({
          minWidth: 0,
          minHeight: 0,
          padding: `${r.spacing(2)} 0`,
          borderBottom: "2px solid transparent",
          "&.Mui-selected": {
            color: r.palette.primary.main,
            borderBottom: `2px solid ${r.palette.primary.main}`
          },
          "&:hover,:focus-visible,&.Eds-tabOpened": {
            color: r.palette.primary.dark,
            borderBottom: `2px solid ${r.palette.primary.dark}`
          }
        }),
        toolbar: ({ theme: r, ownerState: t }) => ({
          width: "100%",
          boxSizing: "border-box",
          [r.breakpoints.up("xl")]: t.maxWidth ?? !0 ? {
            padding: 0,
            maxWidth: `calc(${r.breakpoints.values.xl}px - ${r.spacing(12)})`,
            margin: "auto"
          } : {},
          [r.breakpoints.up("lg")]: {
            padding: `0 ${r.spacing(6)}`
          },
          [r.breakpoints.down("lg")]: {
            padding: `0 ${r.spacing(5)}`
          }
        }),
        paper: ({ theme: r }) => ({
          borderBottom: `1px solid ${r.palette.divider}`,
          boxShadow: "none",
          backgroundColor: r.palette.background.surface,
          zIndex: r.zIndex.appBar,
          position: "fixed",
          right: 0,
          left: 0
        })
      }
    },
    NavigationalDrawer: {
      styleOverrides: {
        defaultRoot: ({ theme: r }) => ({
          "& .MuiDrawer-paper": {
            minWidth: r.spacing(27),
            maxWidth: r.spacing(42),
            width: r.spacing(42),
            [r.breakpoints.down("sm")]: {
              width: "93%"
            }
          }
        }),
        navListItemButton: ({ theme: r }) => ({
          padding: `${r.spacing(1)} ${r.spacing(3)}`,
          "&.Mui-selected": {
            borderLeft: `2px solid ${r.palette.primary.main}`,
            "&:active": {
              backgroundColor: n.surface.selectedPressed
            }
          },
          "&:active": {
            backgroundColor: r.palette.action.active
          }
        })
      }
    },
    SelectionCard: {
      styleOverrides: {
        root: ({ theme: r, ownerState: t }) => ({
          borderRadius: r.spacing(1),
          border: `1px solid ${n.border.mediumEmphasis}`,
          outline: "1px solid transparent",
          outlineOffset: "2px",
          boxSizing: "border-box",
          // User Story 1023385: If a card is checked or has an error, its border width is 2px. Otherwise, the border's width is 1px.
          // The spacing and layout of the content inside the card is impacted by the border width.
          // To maintain the spacing and layout of the content inside the card, the padding of the card is set to 0 when the border width is 2px; set to 1px when the border width is 1px.
          padding: t.checked || t.error ? 0 : "1px",
          // Set button to full height of card so it will be aligned correctly
          [`& .${O.root}`]: {
            height: "100%"
          },
          // Label root class (contains label and checkbox)
          "& .input-content": {
            gap: r.spacing(2),
            ...r.typography.subtitle300,
            // Set width to stretch across full width of card
            width: "100%",
            display: "flex",
            alignItems: "center",
            svg: {
              padding: r.spacing(1),
              borderRadius: "50%"
            }
          },
          [`& .${Y.root}`]: {
            display: "flex",
            alignItems: "center",
            height: "100%",
            boxSizing: "border-box"
          },
          "&.Mui-focusVisible": {
            outline: `1px solid ${r.palette.primary.main}`
          },
          // Override MUI to keep card background color from changing on focus
          [`& .${O.focusVisible},.${O.focusHighlight}`]: {
            backgroundColor: "transparent"
          },
          "&:hover": {
            padding: 0,
            // User Story 1023385: due to the border-width of checked or error state selection card
            border: `2px solid ${r.palette.primary.dark}`,
            [`& .${O.root}:hover`]: {
              backgroundColor: "transparent",
              [`& .${O.focusHighlight}`]: {
                opacity: 0
              }
            },
            // Set radio button styles
            "& .input-content": {
              svg: {
                backgroundColor: r.palette.action.hover,
                color: r.palette.primary.dark
              }
            }
          },
          "&:active": {
            padding: 0,
            // User Story 1023385: due to the border-width of checked or error state selection card
            border: `2px solid ${r.palette.primary.dark}`,
            "& .input-content": {
              svg: {
                backgroundColor: r.palette.action.active,
                color: n.border.colorPressed
              }
            }
          }
        })
      },
      variants: [
        {
          props: { orientation: "landscape" },
          style: ({ theme: r }) => ({
            width: "100%",
            minWidth: r.spacing(39),
            height: r.spacing(10),
            img: {
              width: r.spacing(7),
              height: r.spacing(7),
              aspectRatio: "1 / 1"
            }
          })
        },
        {
          props: { orientation: "portrait" },
          style: ({ theme: r }) => ({
            width: "100%",
            height: "100%",
            minWidth: r.spacing(26),
            maxWidth: r.spacing(44),
            minHeight: r.spacing(30),
            aspectRatio: "19 / 20",
            "& .input-content": {
              width: "auto",
              padding: r.spacing(2),
              gap: r.spacing(1),
              display: "flex"
            },
            [`& .${Y.root}`]: {
              display: "flex",
              alignItems: "stretch",
              flexDirection: "column-reverse",
              padding: 0
            },
            "& .card-image": {
              padding: r.spacing(3),
              display: "flex",
              width: "auto",
              height: "100%",
              minHeight: r.spacing(5),
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "-1px",
              // User Story 1023385: due to the extra 1px padding when not checked or in error state,
              marginRight: "-1px",
              // to fill in the gap from the extra 1px padding
              borderBottom: `1px solid ${r.palette.action.active}`,
              img: {
                width: "100%",
                height: "100%",
                minWidth: r.spacing(9),
                maxWidth: r.spacing(24),
                minHeight: r.spacing(9),
                maxHeight: r.spacing(24),
                aspectRatio: "1 / 1"
              }
            }
          })
        },
        {
          props: { checked: !0 },
          style: ({ theme: r }) => ({
            backgroundColor: r.palette.info.light,
            border: `2px solid ${r.palette.primary.main}`,
            "& .input-content": {
              svg: {
                color: r.palette.primary.main
              },
              "& .MuiTypography-root": {
                fontWeight: V,
                color: r.palette.primary.dark
              }
            },
            "&:hover": {
              "& .input-content": {
                svg: {
                  backgroundColor: r.palette.action.hover
                }
              }
            },
            "&:active": {
              "& .input-content": {
                svg: {
                  backgroundColor: r.palette.action.active
                }
              }
            }
          })
        },
        {
          props: { error: !0 },
          style: ({ theme: r }) => ({
            border: `2px solid ${r.palette.error.main}`,
            color: r.palette.error.main,
            "& .input-content": {
              svg: {
                color: r.palette.error.main
              },
              "& .MuiTypography-root": {
                color: r.palette.error.dark
              }
            },
            "&:hover": {
              border: `2px solid ${r.palette.error.dark}`,
              "& .input-content": {
                svg: {
                  color: r.palette.error.dark
                }
              }
            },
            "& .card-image": {
              // Filter image red
              img: {
                filter: "brightness(0) saturate(100%) invert(9%) sepia(89%) saturate(7058%) hue-rotate(9deg) brightness(91%) contrast(111%)"
              }
            }
          })
        },
        {
          props: { error: !0, checked: !0 },
          style: ({ theme: r }) => ({
            backgroundColor: r.palette.error.light,
            border: `2px solid ${n.border.error}`
          })
        },
        {
          props: { disabled: !0 },
          style: ({ theme: r }) => ({
            border: `1px solid ${r.palette.grey[200]}`,
            "& .input-content": {
              svg: {
                color: r.palette.grey[400]
              },
              "& .MuiTypography-root": {
                color: r.palette.grey[400]
              }
            },
            pointerEvents: "none",
            "& .card-image": {
              opacity: 0.6,
              // Filter image to disabled color
              img: {
                filter: "brightness(0) saturate(100%) invert(77%) sepia(7%) saturate(132%) hue-rotate(155deg) brightness(90%) contrast(87%)"
              }
            }
          })
        },
        {
          props: { disabled: !0, checked: !0 },
          style: ({ theme: r }) => ({
            backgroundColor: "transparent",
            border: `1px solid ${r.palette.grey[200]}`
          })
        }
      ]
    },
    AppBar: {
      styleOverrides: {
        toolbar: ({ theme: r, ownerState: t }) => ({
          [r.breakpoints.up("xl")]: t.maxWidth ?? !0 ? {
            maxWidth: `calc(${r.breakpoints.values.xl}px - ${r.spacing(12)})`,
            width: "100%",
            margin: "auto",
            padding: `${r.spacing(2)} 0`
          } : {},
          [r.breakpoints.up("lg")]: {
            padding: `${r.spacing(2)} ${r.spacing(6)}`,
            minHeight: r.spacing(5)
          },
          [r.breakpoints.down("lg")]: {
            padding: `${r.spacing(2)} ${r.spacing(5)}`,
            minHeight: r.spacing(5)
          },
          [r.breakpoints.down("md")]: {
            padding: `${r.spacing(2)} ${r.spacing(4)}`,
            minHeight: r.spacing(5)
          },
          [r.breakpoints.down("sm")]: {
            padding: r.spacing(2),
            minHeight: r.spacing(5)
          }
        })
      }
    },
    SelectionSummaryField: {
      styleOverrides: {
        root: () => ({
          "& .MuiTypography-root": {
            whiteSpace: "break-spaces"
          }
        })
      },
      variants: [
        {
          props: { disabled: !0 },
          style: ({ theme: r }) => ({
            "& .MuiCard-root": {
              border: `1px solid ${r.palette.grey[200]}`,
              "& .MuiTypography-root": {
                color: r.palette.grey[400]
              }
            }
          })
        }
      ]
    },
    TabBar: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          width: "auto",
          height: 40,
          minHeight: 40,
          borderBottom: `1px solid ${r.palette.divider}`,
          borderTop: `1px solid ${r.palette.divider}`,
          [`& .${S.indicator}`]: {
            bottom: "unset",
            top: 0,
            height: "2px",
            backgroundColor: r.palette.primary.dark
          },
          [`& .${S.scrollButtons}`]: {
            backgroundColor: r.palette.background.surface,
            border: `1px solid ${r.palette.divider}`,
            width: 40,
            height: 40,
            boxSizing: "content-box"
          },
          [`& .${S.flexContainer}`]: {
            backgroundColor: r.palette.background.surface,
            width: "fit-content"
          },
          [`.${S.scrollButtons}.Mui-disabled`]: {
            display: "none"
          }
        })
      }
    },
    TabItem: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          width: "auto",
          maxWidth: 256,
          height: 40,
          minHeight: 40,
          letterSpacing: "1px",
          borderRight: `1px solid ${r.palette.divider}`,
          borderLeft: `1px solid ${r.palette.divider}`,
          "&:not(:first-of-type)": {
            borderLeft: "none"
          },
          fontSize: r.typography.subtitle200.fontSize,
          fontWeight: V,
          paddingTop: r.spacing(1),
          paddingBottom: r.spacing(1),
          paddingLeft: r.spacing(3),
          paddingRight: r.spacing(3),
          outline: "none",
          "&:hover": {
            backgroundColor: r.palette.action.hover
          },
          "&:active": {
            backgroundColor: r.palette.action.active
          },
          "&.Mui-focusVisible": {
            outline: "auto",
            outlineColor: r.palette.primary.dark,
            outlineOffset: "-10px"
          },
          [`&.${jr.selected}`]: {
            backgroundColor: r.palette.action.selected,
            color: r.palette.primary.dark,
            outline: "none",
            "&:not(:first-of-type)": {
              marginLeft: "-1px"
            },
            "&:hover": {
              backgroundColor: r.palette.action.hover
            },
            //review this css rule with eds team
            "&:focus-visible": {
              outline: "auto",
              outlineColor: r.palette.primary.dark,
              outlineOffset: "-10px"
            }
          },
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "inline-block"
        })
      },
      variants: [
        {
          props: { fullLabel: !0 },
          style: ({ theme: r }) => ({
            minWidth: "max-content"
          })
        }
      ]
    }
  },
  typography: {
    ...b
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1240,
      lg: 1440,
      xl: 1920
    }
  }
}, f = {
  primaryDark: "#004986",
  primaryMain: o.primary.main,
  accent: o.primary.light,
  error: "#da0303",
  muted: "#6b6b6b",
  disabled: "#666666"
}, ks = {
  palette: {
    common: {
      black: "#000000",
      white: "#FFFFFF"
    },
    action: {
      activatedOpacity: 0.54,
      hoverOpacity: 0.04,
      hover: "rgba(0, 113, 199, 0.08)",
      selected: "rgba(0, 113, 199, 0.08)",
      selectedOpacity: 0.08,
      disabled: "rgba(0, 0, 0, 0.26)",
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.3
    },
    primary: {
      dark: f.primaryDark,
      main: f.primaryMain,
      light: f.accent,
      contrastText: "white"
    },
    success: {
      main: "#008015"
    },
    error: {
      main: "#DA0303"
    },
    warning: {
      main: "#FFB800"
    },
    info: {
      main: "#005CB9"
    },
    grey: {
      900: "#111112",
      800: "#36383A",
      700: "#545658",
      600: "#63676A",
      500: "#868A8D",
      400: "#AAAEB0",
      300: "#D3D5D6",
      200: "#E5E6E7",
      100: "#EEEFEF",
      50: "#F6F7F8"
    },
    divider: "#E5E6E7",
    background: {
      default: "#F4F4F4",
      paper: "#FFFFFF"
    },
    text: {
      primary: f.primaryDark,
      secondary: f.muted,
      disabled: f.disabled
    }
  },
  shape: {
    borderRadius: 4
  },
  typography: {
    ...Os(),
    fontFamily: "Yantramanav,'Open Sans',sans-serif;"
  },
  shadows: _s(),
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: f.accent
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF"
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          "& svg": {
            border: "1px solid transparent",
            borderRadius: "4px"
          },
          "&:hover": {
            backgroundColor: r.palette.action.hover,
            color: r.palette.primary.dark
          },
          "&.Mui-focusVisible": {
            "& svg": {
              borderColor: r.palette.primary.main
            }
          },
          color: f.primaryDark
        })
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          color: f.primaryDark,
          "& svg": {
            border: "1px solid transparent",
            borderRadius: "100%"
          },
          "&:hover": {
            backgroundColor: r.palette.action.hover,
            color: r.palette.primary.dark
          },
          "&.Mui-focusVisible": {
            "& svg": {
              borderColor: r.palette.primary.main
            }
          }
        })
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          color: r.palette.primary.dark
        })
      }
    }
  }
};
function _s(r = 2) {
  const e = [...Kr().shadows];
  for (let a = 0; a <= r; a++)
    e[a] = "none";
  return e;
}
function Os() {
  const e = JSON.parse(
    JSON.stringify(zr.typography)
  );
  for (const a in e) {
    const i = e[a];
    if (i && (typeof i.fontWeight == "number" && (i.fontWeight += -100), typeof i.fontSize == "string")) {
      const s = Number(i.fontSize.split("px")[0]);
      i.fontSize = `${s + 2}px`;
    }
  }
  return e;
}
const T = Cs();
function xr(r, t) {
  return `linear-gradient(${r}, ${r}), linear-gradient(${t}, ${t})`;
}
const As = {
  palette: {
    background: {
      default: n.background.primary
    }
  },
  typography: {
    ...b,
    htmlFontSize: 10,
    // This needs to be removed when Online is no longer using bootstrap
    caption: b.body2,
    overline: b.h6,
    display1: b.display100,
    display2: b.display200,
    display3: b.display300,
    h1: b.heading100,
    h2: b.heading200,
    h3: b.heading300,
    h4: b.heading400,
    h5: b.heading500,
    h6: b.heading600,
    subtitle1: b.subtitle100,
    subtitle2: b.subtitle200,
    body1: b.body100,
    body2: b.body200
  },
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        expandIconWrapper: ({ theme: r }) => ({
          borderRadius: T.radiusContainer,
          color: r.palette.typography.lowEmphasis,
          transition: "unset",
          "&:hover": {
            backgroundColor: r.palette.action.hover,
            color: r.palette.primary.dark
          },
          padding: r.spacing(1)
        })
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          boxShadow: "none",
          borderBottom: `1px solid ${y.appBar.color.surface}`,
          button: {
            color: r.palette.common.white,
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.2)",
              color: r.palette.common.white
            },
            "&:active": {
              backgroundColor: "rgba(255,255,255,0.38)",
              color: r.palette.common.white
            },
            "&.Mui-focusVisible": {
              outlineColor: m.color.primary[200]
            }
          },
          "& .MuiInputAdornment-root button": {
            color: r.palette.grey[700],
            "&:hover": {
              backgroundColor: r.palette.action.hover,
              color: r.palette.primary.dark
            },
            "&:active": {
              backgroundColor: r.palette.action.active,
              color: r.palette.grey[700]
            },
            "&.Mui-focusVisible": {
              outlineColor: r.palette.primary.light
            },
            [`& .${w.root}`]: {
              boxSizing: "content-box"
            },
            [`& .${Z.root}`]: {
              background: r.palette.background.paper
            },
            [`& .${rr.notchedOutline}`]: {
              borderWidth: "0px"
            },
            "& .MuiBadge-badge": {
              backgroundColor: m.color.primary[200],
              // dark theme value: primary[200]
              color: m.color.grey[900]
            }
          },
          backgroundColor: y.appBar.color.surface,
          color: y.appBar.color.onSurface,
          [`& .${w.root} .${Lr.root} > *`]: {
            color: "inherit"
          },
          [`& .${w.root} .${Vr.root} .${Gr.root}`]: {
            color: y.appBar.color.onSurface
          },
          [`& .${w.root}`]: {
            boxSizing: "content-box"
          },
          [`& .${Z.root}`]: {
            background: y.appBar.color.inputBackground
          },
          [`& .${rr.notchedOutline}`]: {
            borderWidth: "0px"
          },
          "& .MuiBadge-badge": {
            backgroundColor: m.color.primary[200],
            // dark theme value: primary[200]
            color: m.color.grey[900]
          }
        })
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState: r, theme: t }) => ({
          fontSize: t.typography.button.fontSize,
          height: t.spacing(5),
          borderRadius: T.radiusContainer,
          ...typeof r.children == "string" ? {
            outlineOffset: "2px",
            whiteSpace: "nowrap",
            padding: "8px 16px",
            ...r.size === "small" && {
              fontSize: "12px",
              height: "24px",
              padding: "4px 8px",
              overflow: "hidden",
              overflowWrap: "anywhere",
              textOverflow: "ellipsis",
              lineHeight: "0px",
              position: "relative",
              "&.MuiButton-startIcon": {
                marginRight: "4px"
              },
              "&.MuiButton-endIcon": {
                marginLeft: "4px"
              }
            }
          } : {
            minWidth: t.spacing(5),
            width: t.spacing(5),
            padding: t.spacing(1),
            ...r.size === "small" && {
              color: t.palette.grey[800],
              minWidth: "20px",
              padding: "4px",
              width: "auto",
              height: "auto"
            }
          },
          "&.Mui-focusVisible": {
            outline: `2px solid ${t.palette.primary.main}`
          },
          ...r.variant === "contained" ? {
            "&:active": {
              backgroundColor: "#003A6B"
            }
          } : {
            "&:hover": {
              backgroundColor: y.button.color.secondary.surfaceHover,
              color: t.palette.primary.dark,
              ...r.variant === "outlined" && {
                borderColor: t.palette.primary.dark
              }
            },
            "&:active": {
              backgroundColor: t.palette.action.active,
              color: t.palette.primary.dark
            },
            ...r.variant === "outlined" && {
              border: `1px solid ${t.palette.primary.main}`
            }
          }
        })
      }
    },
    MuiButtonGroup: {
      styleOverrides: {
        firstButton: ({ ownerState: r, theme: t }) => ({
          outlineOffset: "-3px",
          borderRightWidth: "1px",
          borderRightColor: r.variant === "contained" ? y.button.color.primary.borderSeparator : y.button.color.secondary.borderSeparator,
          "&.Mui-disabled": {
            borderRightColor: r.variant === "contained" ? t.palette.dividers.mediumEmphasis : y.button.color.secondary.borderSeparator
          },
          "&:hover": {
            borderRightWidth: "1px",
            borderRightColor: "transparent"
          },
          "&.Mui-focusVisible": {
            outline: `1px solid ${r.variant === "contained" ? t.palette.common.white : t.palette.primary.main}`
          }
        }),
        lastButton: ({ ownerState: r, theme: t }) => ({
          marginLeft: r.variant === "contained" ? 0 : "-2px",
          outlineOffset: "-3px",
          borderLeftColor: "transparent",
          "&:hover": {
            borderLeftColor: "transparent"
          },
          "&.Mui-focusVisible": {
            outline: `1px solid ${r.variant === "contained" ? t.palette.common.white : t.palette.primary.main}`
          }
        })
      }
    },
    MuiIcon: {
      styleOverrides: {
        root: {
          fontSize: y.iconography.shape.height
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme: r, ownerState: t }) => ({
          borderRadius: T.radiusContainer,
          "&.Mui-focusVisible": {
            outlineOffset: "2px",
            outline: "1px solid",
            outlineColor: `${r.palette.primary.main}`
          },
          "&:hover": {
            backgroundColor: r.palette.action.hover
          },
          "&:active": {
            backgroundColor: r.palette.action.active
          },
          ...(!t.color || t.color === "default") && {
            color: r.palette.primary.main
            // only set color if none was provided via the `color` prop (to maintain MUI's support for the `color` prop on their InputButton)
          }
        })
      }
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: ({ theme: r }) => ({
          borderRadius: T.radiusContainer,
          color: r.palette.primary.main,
          fontSize: r.typography.button.fontSize,
          fontWeight: r.typography.button.fontWeight,
          lineHeight: r.typography.button.lineHeight,
          letterSpacing: r.typography.button.letterSpacing,
          "&.Mui-focusVisible": {
            border: `1px solid ${r.palette.primary.main}`,
            backgroundColor: "transparent"
          },
          "&:hover": {
            background: r.palette.action.hover
          },
          "&:active": {
            color: r.palette.primary.dark,
            background: r.palette.action.active
          },
          "&.Mui-selected": {
            color: r.palette.grey[900],
            background: xr(
              r.palette.action.selected,
              r.palette.action.selected
            ),
            "&:hover": {
              background: xr(
                r.palette.action.selected,
                r.palette.action.selected
              )
            },
            "&.Mui-focusVisible": {
              backgroundColor: "transparent"
            }
          },
          "&.Mui-disabled": {
            color: r.palette.grey[400]
          },
          "&.MuiPaginationItem-ellipsis": {
            color: r.palette.grey[800],
            background: "transparent"
          }
        })
      }
    }
  }
}, Wr = Hr({
  themeName: void 0
}), Ds = () => Dr(Wr), I = /* @__PURE__ */ new Map();
I.set("Navisphere Online", Yr);
I.set("Navisphere Carrier", Zr);
I.set("FreightQuote by CHR", ks);
I.set("Unstable Single UI", As);
function Fs(r) {
  const t = I.get(r) || {}, e = fr({}, zr), a = fr(e, t);
  return Ur(a);
}
function js(r) {
  return /* @__PURE__ */ N.createElement(Wr.Provider, { value: { themeName: r.theme || void 0 } }, /* @__PURE__ */ N.createElement(Nr, { theme: Fs(r.theme) }, r.children));
}
export {
  js as C,
  Fs as c,
  Ds as u
};
